/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolMagicWandIcon16Light = forwardRef('ToolMagicWandIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.5.25a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-1 0V.75a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M9.5 9.5a.5.5 0 0 1 .5.5v2.25a.5.5 0 0 1-1 0V10a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M9.854 6.146a.5.5 0 0 1 0 .707l-7 7a.5.5 0 0 1-.708-.707l7-7a.5.5 0 0 1 .708 0Z" }),
        React.createElement("path", { d: "M13.92 2.788a.5.5 0 1 0-.708-.707l-1.768 1.767a.5.5 0 0 0 .708.707l1.767-1.767Z" }),
        React.createElement("path", { d: "M5.08 2.08a.5.5 0 0 1 .708 0l1.767 1.768a.5.5 0 1 1-.707.707L5.081 2.788a.5.5 0 0 1 0-.707Z" }),
        React.createElement("path", { d: "M11.444 8.445a.5.5 0 0 1 .708 0l1.767 1.767a.5.5 0 1 1-.707.707l-1.768-1.767a.5.5 0 0 1 0-.707Z" }),
        React.createElement("path", { d: "M3.75 6a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1H3.75Z" }),
        React.createElement("path", { d: "M12.75 6a.5.5 0 1 0 0 1h2.5a.5.5 0 0 0 0-1h-2.5Z" })));
});
